import { cancelAnimations, playAnimation, settleAnimations } from './motion-runner.js';

const EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

/**
 * The height-and-fade of a `<details>` opening or closing.
 *
 * The caller owns `open`, `inert` and `aria-expanded` - it has to set `open` before it can measure the
 * expanded height - and it owns clearing the inline `height`/`overflow` this leaves behind, because on a
 * close the element must not snap back to its natural height before the caller has set `open` to false.
 */
export async function playDetailsHeightMotion(details, content, { startHeight, endHeight, expanded, duration }) {
    details.style.setProperty('height', `${startHeight}px`);
    details.style.setProperty('overflow', 'hidden');

    const animations = [
        playAnimation(details, [
            { height: `${startHeight}px`, overflow: 'hidden' },
            { height: `${endHeight}px`, overflow: 'hidden' },
        ], { duration, easing: EASING, fill: 'forwards' }),
        playAnimation(content, expanded ? [
            { opacity: 0, transform: 'translateY(-6px)' },
            { opacity: 1, transform: 'translateY(0)' },
        ] : [
            { opacity: 1, transform: 'translateY(0)' },
            { opacity: 0, transform: 'translateY(-6px)' },
        ], { duration: Math.min(duration, 220), easing: EASING, fill: 'both' }),
    ].filter(Boolean);

    await settleAnimations(animations);
    cancelAnimations(animations);
}
